import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'

const PasswordUpdateUI = ({context, messageList, successMsg, errorList,
    submitted, onSubmit, onCancel, setErrorList,
    oldPassword, oldPasswordError, onOldPasswordChange, setOldPasswordError,
    newPassword, newPasswordError, onNewPasswordChange, setNewPasswordError,
    reenterPassword, reenterPasswordError, onReenterPasswordChange, setReenterPasswordError
  }) =>
  <CardUI context={context}>
    <FormSF context={context}
      messageList={messageList} buttonMessageKey='c_update' cancelMessageKey='c_cancel'
      successMsg={successMsg} errorList={errorList}
      busy={submitted} onSubmit={onSubmit} onCancel={onCancel} setErrorList={setErrorList}
    >
      <InputTextSF type='password' name='oldPassword' required={true} maxLength={40}
        messageList={messageList} labelKey='c_old_password'
        value={oldPassword} error={oldPasswordError} onChange={onOldPasswordChange} setError={setOldPasswordError}
        autoFocus={true}
      />
      <InputTextSF type='password' name='newPassword' required={true} maxLength={40}
        messageList={messageList} labelKey='c_new_password'
        value={newPassword} error={newPasswordError} onChange={onNewPasswordChange} setError={setNewPasswordError}
      />
      <InputTextSF type='password' name='reenterPassword' required={true} maxLength={40}
        messageList={messageList} labelKey='c_reenter_password'
        value={reenterPassword} error={reenterPasswordError} onChange={onReenterPasswordChange} setError={setReenterPasswordError}
      />
    </FormSF>
  </CardUI>

export default PasswordUpdateUI
